/** @jsxImportSource @emotion/react */
import React from "react";
import {css} from "@emotion/react";

import {betterMemo} from "js/common/utils/more-memo";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";
import LeaderboardAvatar from "js/dashboards/components/leaderboard/leaderboard-avatar";
import {bronze, gold, greyDark, silver} from "js/common/cube19-colors";

const leaderBoardRankColors = {
  1: gold,
  2: silver,
  3: bronze
};

const rowStyle = (theme, firstPlace) => css`
  display: flex;
  align-items: center;
  padding: 8px;
  margin: 0;
  border-bottom: ${!firstPlace ? `1px solid ${theme.palette.border.lightest}` : "none"};
  cursor: pointer;
  position: relative;
  border-radius: ${firstPlace ? "5px" : "0"};
  color: ${firstPlace ? greyDark : theme.palette.text.main};
  background-color: ${firstPlace ? theme.palette.background.warning : "transparent"};

  &:hover {
    background-color: ${theme.palette.background.paper};
    cursor: pointer;
    color: ${theme.palette.text.main};
  }
`;

const RankBadge = ({theme, rank}) => {
  const backgroundColor = leaderBoardRankColors[rank] ?? theme.palette.background.card;
  const isTopThree = rank <= 3;
  return <div
      style={{
        width: 20,
        height: 20,
        borderRadius: "7px",
        transform: "rotate(45deg)",
        backgroundColor,
        color: isTopThree ? "white" : theme.palette.text.main,
        border: isTopThree ? "none" : `1px solid ${theme.palette.border.light}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: 15,
        fontSize: 12,
        fontWeight: "bold"
      }}>
    <div style={{transform: "rotate(-45deg)"}}>{rank}</div>
  </div>;
};

const LeaderboardRow = betterMemo({displayName: "LeaderboardRow"}, ({
  rank,
  user,
  value,
  onClick,
  sortField,
  percentOfTarget
}) => {
  const {theme} = React.useContext(CustomThemeContext);
  const firstPlace = rank === 1;
  return (
      <div
          css={rowStyle(theme, firstPlace)}
          onClick={() => onClick(user.get("id"))}>

        <RankBadge theme={theme} rank={rank} />

        <LeaderboardAvatar rank={rank} user={user} />

        <div style={{flex: 1}}>
          <div style={{fontSize: 14}}>{user.get("fullName")}</div>
        </div>

        <div style={{display: "flex", flexWrap: "wrap", float: "right", marginRight: 0}}>
          <div style={{fontWeight: "bold"}}>{sortField === "VALUE" ? value : percentOfTarget}</div>
        </div>
      </div>
  );
});

export default LeaderboardRow;
